import { render, staticRenderFns } from "./MemberVipLayer.vue?vue&type=template&id=00aff876&scoped=true&"
import script from "./MemberVipLayer.vue?vue&type=script&lang=js&"
export * from "./MemberVipLayer.vue?vue&type=script&lang=js&"
import style0 from "./MemberVipLayer.vue?vue&type=style&index=0&id=00aff876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aff876",
  null
  
)

export default component.exports